<ng-container *transloco="let t; read: TRANSLATION_SCOPE">
  <div class="modal-container">
    <div class="modal-container-right">
      <div class="modal-header">
        <rx-button buttonClass="subtle-circle" (click)="close()">
          <i class="rx-close"></i>
        </rx-button>
      </div>
      <div class="modal-body">
        <h3 class="modal-title">
          {{ t('title') }}
        </h3>
        <img
          class="modal-roomex-logo"
          [src]="logo"
        />
        <p class="mb-5">{{ t('text') }}</p>
        <b [innerHtml]=" t('howToAdd')"></b>
      </div>
    </div>
  </div>
</ng-container>
